import { render, staticRenderFns } from "./FilePngIcon.vue?vue&type=template&id=aac20dba"
import script from "./FilePngIcon.vue?vue&type=script&lang=js"
export * from "./FilePngIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports